import { Alert } from 'react-bootstrap';

const Message = ({ variant, children }) => {
 
  return (
    // <div style={containerStyle}>
    <div>
      <Alert variant={variant} style={messageStyle}>
        {children}
      </Alert>
    </div>
  );
}

// const containerStyle = {
//   top: '150px',
//   right: '50px',
//   maxWidth: '300px',
// };

const messageStyle = {
  marginBottom: '10px',
};

Message.defaultProps = {
  variant: 'info',
};

export default Message;
